cobalt-radio-button {
  display: flex;
}

cobalt-radio-button .core-radio-button .radio-button-wrapper {
  padding: var(--number-spacing-none);
}
